/**
 * Sort options configuration for PBH orders
 * Defines the available sort fields and their API field name mappings
 */

export interface SortOption {
  /**
   * Display label shown in the UI dropdown
   */
  label: string;
  /**
   * API field name used for sorting (e.g., "CreationDate", "CustomerPO")
   */
  value: string;
}

/**
 * Available sort options for PBH orders
 * These are the sort fields displayed in the toolbar dropdown
 *
 * Order matches the UI display order from the design:
 * 1. Creation Date (default)
 * 2. PO No.
 * 3. Part Number
 * 4. UnServiceable Part Status
 * 5. AJW SO
 * 6. Priority
 * 7. Company Name
 * 8. Serviceable Part Status
 */
export const PBH_SORT_OPTIONS: SortOption[] = [
  { label: "Creation Date", value: "CreationDate" },
  { label: "PO No.", value: "CustomerPO" },
  { label: "Part Number", value: "PartNumber" },
  { label: "UnServiceable Part Status", value: "InboundStatus" },
  { label: "AJW SO", value: "AJWSO" },
  { label: "Priority", value: "CustomerPriority" },
  { label: "Company Name", value: "CompanyName" },
  { label: "Serviceable Part Status", value: "OutboundStatus" },
];

/**
 * Default sort configuration
 * Used when no sort is specified in URL or initial state
 */
export const DEFAULT_SORT_BY = "CreationDate";
export const DEFAULT_SORT_ORDER = "desc" as const;

